{
  "name": "wonder-budget",
  "version": "1.4.1",
  "license": "MIT",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "test": "ng test",
    "lint": "ng lint",
    "e2e": "ng e2e",
    "extract-i18n": "ng xi18n --output-path src/i18n --locale en && xliffmerge --profile xliffmerge.json",
    "start:local": "npx ng serve --configuration=stage",
    "start:local:dev": "npx ng serve --configuration=local",
    "deploy:prod": "ng build --aot --configuration=production && firebase use prod && firebase deploy",
    "deploy:stage": "ng build --aot --configuration=stage && firebase use stage && firebase deploy"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^19.1.0",
    "@angular/cdk": "^19.1.0",
    "@angular/common": "^19.1.0",
    "@angular/compiler": "^19.1.0",
    "@angular/core": "^19.1.0",
    "@angular/fire": "^19.0.0",
    "@angular/forms": "^19.1.0",
    "@angular/material": "^19.1.0",
    "@angular/material-moment-adapter": "^19.1.0",
    "@angular/platform-browser": "^19.1.0",
    "@angular/platform-browser-dynamic": "^19.1.0",
    "@angular/router": "^19.1.0",
    "@swimlane/ngx-charts": "^22.0.0",
    "angular7-csv": "^0.2.12",
    "core-js": "^3.49.0",
    "firebase": "^11.1.0",
    "moment": "^2.30.1",
    "moment-timezone": "^0.5.48",
    "ngx-editor": "^18.0.0",
    "rxjs": "^7.8.2",
    "xlsx": "^0.17.5",
    "zone.js": "^0.15.0"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^19.1.0",
    "@angular/cli": "^19.1.0",
    "@angular/compiler-cli": "^19.1.0",
    "@angular/language-service": "^19.1.0",
    "@angular/localize": "^19.1.0",
    "@types/jasmine": "~5.1.0",
    "@types/jasminewd2": "~2.0.10",
    "@types/moment-timezone": "^0.5.30",
    "@types/node": "^20.11.0",
    "angular-eslint": "^19.0.2",
    "eslint": "^9.16.0",
    "firebase-admin": "^13.0.0",
    "jasmine": "^5.4.0",
    "jasmine-core": "~5.4.0",
    "jasmine-spec-reporter": "~7.0.0",
    "protractor": "~7.0.0",
    "ts-node": "~10.9.2",
    "typescript": "~5.6.3",
    "typescript-eslint": "^8.18.0"
  }
}